import React from 'react';

const IconLogo = () => (
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 84 84">
    <title>Logo</title>
    <circle cx="42" cy="42" r="35" stroke="currentColor" strokeWidth="4" fill="none" />
  </svg>
);

export default IconLogo;
